/**
 * Invoice List Translations (B2B)
 * ================================
 * Same keys as B2C for shared invoice terminology
 */

import { Translations } from '../shared/i18n';

export const invoiceListTranslations: Translations = {
    tr: {
        // Columns
        colFilename: 'Dosya Adı',
        colSupplier: 'Tedarikçi',
        colExpenseCategory: 'Gider Türü',
        colTaxId: 'Vergi No',
        colAddress: 'Adres',
        colInvoiceNumber: 'Fatura No',
        colInvoiceDate: 'Fatura Tarihi',
        colDueDate: 'Vade Tarihi',
        colTotalAmount: 'Gider Tutarı',
        colCurrency: 'Para Birimi',
        colTax: 'KDV',
        colNetAmount: 'Net Tutar',
        colLineItems: 'Kalem Sayısı',
        colCreatedAt: 'Yüklenme',

        // Categories
        catFood: 'Yiyecek ve İçecek',
        catFuel: 'Akaryakıt',
        catAccommodation: 'Konaklama',
        catTransport: 'Ulaşım',
        catToll: 'Otoyol/Köprü Geçiş',
        catParking: 'Otopark',
        catOfficeSupplies: 'Kırtasiye/Ofis',
        catCommunication: 'İletişim',
        catOther: 'Diğer',

        // Actions
        view: 'Görüntüle',
        viewTooltipSingle: 'Tek bir fatura seçiniz',
        viewTooltipReady: 'Fatura detayını görüntüle',
        bulkUpload: 'Gider Yükle',
        deleteConfirm: '{count} fatura silinecek. Emin misiniz?',
        deleteError: 'Silme sırasında bir hata oluştu.',
        exportError: 'Export sırasında bir hata oluştu.',

        // Processing banner
        processingCount: '{count} fatura işleniyor...',
        statusProcessing: 'İşleniyor',
        statusPending: 'Bekliyor',

        // Upload modal
        uploadTitle: 'Gider Yükleme',
        dropzoneText: 'Dosyaları sürükleyin veya seçmek için tıklayın',
        dropzoneHover: 'Dosyaları buraya bırakın',
        dropzoneHint: 'PDF, PNG, JPG (max 10MB)',
        filesSelected: '{count} dosya seçildi',
        clearAll: 'Tümünü Temizle',
        uploadButton: '{count} Dosya Yükle',
        cancelUpload: 'İptal Et',
        uploadProgress: '{done} / {total} dosya yüklendi',
        uploadSuccess: '{count} başarılı',
        uploadError: '{count} hatalı',
        uploadPending: '{count} bekliyor',
        invalidFileType: 'Geçersiz dosya tipi. İzin verilen: {types}',
        fileTooLarge: 'Dosya çok büyük. Maksimum: {size}MB',
        uploadFailed: 'Yükleme başarısız',
        uploadErrorGeneric: 'Yükleme hatası',
        uploadBeforeUnload: 'Yükleme devam ediyor. Sayfadan çıkmak istediğinize emin misiniz?',
        uploadCancelConfirm: 'Yükleme devam ediyor. İptal etmek istediğinize emin misiniz?\nYüklenmiş dosyalar kalacak, bekleyenler iptal edilecek.',

        // Export modal
        exportTitle: 'Excel Olarak Dışa Aktar',
        exportDescription: 'Hangi tarih aralığındaki faturaları dışa aktarmak istiyorsunuz?',
        exportSheetNote: 'Her ay için ayrı bir sayfa (sheet) oluşturulacaktır.',
        preset1m: '1 Ay',
        preset3m: '3 Ay',
        preset6m: '6 Ay',
        preset9m: '9 Ay',
        preset1y: '1 Yıl',
        presetCustom: 'Özel Aralık',
        startDate: 'Başlangıç Tarihi',
        endDate: 'Bitiş Tarihi',
        selectedRange: 'Seçilen Aralık:',
        preparing: 'Hazırlanıyor...',
        downloadExcel: 'Excel İndir',
    },
    en: {
        // Columns
        colFilename: 'Filename',
        colSupplier: 'Supplier',
        colExpenseCategory: 'Expense Category',
        colTaxId: 'Tax ID',
        colAddress: 'Address',
        colInvoiceNumber: 'Invoice No',
        colInvoiceDate: 'Invoice Date',
        colDueDate: 'Due Date',
        colTotalAmount: 'Expense Amount',
        colCurrency: 'Currency',
        colTax: 'VAT',
        colNetAmount: 'Net Amount',
        colLineItems: 'Line Items',
        colCreatedAt: 'Uploaded',

        // Categories
        catFood: 'Food & Beverage',
        catFuel: 'Fuel',
        catAccommodation: 'Accommodation',
        catTransport: 'Transportation',
        catToll: 'Toll',
        catParking: 'Parking',
        catOfficeSupplies: 'Office Supplies',
        catCommunication: 'Communication',
        catOther: 'Other',

        // Actions
        view: 'View',
        viewTooltipSingle: 'Select a single invoice',
        viewTooltipReady: 'View invoice details',
        bulkUpload: 'Upload Expense',
        deleteConfirm: '{count} invoice(s) will be deleted. Are you sure?',
        deleteError: 'An error occurred while deleting.',
        exportError: 'An error occurred during export.',

        // Processing banner
        processingCount: '{count} invoice(s) processing...',
        statusProcessing: 'Processing',
        statusPending: 'Pending',

        // Upload modal
        uploadTitle: 'Upload Expenses',
        dropzoneText: 'Drag files or click to select',
        dropzoneHover: 'Drop files here',
        dropzoneHint: 'PDF, PNG, JPG (max 10MB)',
        filesSelected: '{count} file(s) selected',
        clearAll: 'Clear All',
        uploadButton: 'Upload {count} File(s)',
        cancelUpload: 'Cancel',
        uploadProgress: '{done} / {total} files uploaded',
        uploadSuccess: '{count} successful',
        uploadError: '{count} failed',
        uploadPending: '{count} pending',
        invalidFileType: 'Invalid file type. Allowed: {types}',
        fileTooLarge: 'File too large. Maximum: {size}MB',
        uploadFailed: 'Upload failed',
        uploadErrorGeneric: 'Upload error',
        uploadBeforeUnload: 'Upload in progress. Are you sure you want to leave?',
        uploadCancelConfirm: 'Upload in progress. Are you sure you want to cancel?\nUploaded files will be kept, pending files will be cancelled.',

        // Export modal
        exportTitle: 'Export as Excel',
        exportDescription: 'Which date range would you like to export?',
        exportSheetNote: 'A separate sheet will be created for each month.',
        preset1m: '1 Month',
        preset3m: '3 Months',
        preset6m: '6 Months',
        preset9m: '9 Months',
        preset1y: '1 Year',
        presetCustom: 'Custom Range',
        startDate: 'Start Date',
        endDate: 'End Date',
        selectedRange: 'Selected Range:',
        preparing: 'Preparing...',
        downloadExcel: 'Download Excel',
    },
};
